import { styled } from "@mui/material/styles";
import { Box, Grid2 } from "@mui/material";
import { East } from "@mui/icons-material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const VideosGrid = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const YouTubeWrapper = styled(Box)({
  borderRadius: "16px",
  overflow: "hidden",
  width: "100%",
});

export const ViewMoreButtonWrapper = styled(Box)(({ theme }) => ({
  margin: "auto",
  width: "100%",
  justifyContent: "center",
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    ".MuiButton-root": {
      textWrap: "nowrap",
      padding: "10px 40px",
      width: "100%",
    },
  },
}));

export const ViewMoreIcon = styled(East)(({ theme }) => ({
  color: theme.palette.primary.main,
}));
